export default {
      id: "logo-usage",
      viewBox: "0 0 666.66 273.33",
      url: "/dist/svg/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }